module.exports = __webpack_public_path__ + "static/media/releasePlaceholder.976eafba.png";